import Vuex from 'vuex'

import {alert} from './alert.module';
import {authentication} from './authentication.module';
import {users} from './users.module';
import {loader} from './loader.module';
import {configs} from './configs.module';
import {shop} from './shop/shop.module';

export const store = new Vuex.Store({
    modules: {
        alert,
        authentication,
        users,
        loader,
        configs,
        shop,
    }
});

